import request from '@/utils/request'
export function fetchList(query) {
    return request({
        url: '/upkeep/order/item/cost/page',
        method: 'get',
        params: query,
    })
}